import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  success: null,
};

const roverDataSlice = createSlice({
  name: "roverData",
  initialState,
  reducers: {
    fetchRoverDataStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = null;
    },
    fetchRoverDataSuccess(state, action) {
      state.isLoading = false;
      state.success = true;
      state.data = action.payload;
      state.error = null;
    },
    fetchRoverDataFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
      state.data = [];
    },
    resetRoverDataState() {
      return initialState;
    },
  },
});

export const {
  fetchRoverDataStart,
  fetchRoverDataSuccess,
  fetchRoverDataFailure,
  resetRoverDataState,
} = roverDataSlice.actions;
export default roverDataSlice.reducer;
